// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__qHdLh","modal":"Modal_modal__6QRaV","slide-down":"Modal_slide-down__3nSra"};